/**
 * ACTIVITY-CORE (L1) — revert compensatorio server-side desde el feed.
 *
 * `POST /api/activity/{id}/revert`: el servidor aplica los `old` del patch por
 * el write-path normal y registra una entrada `reverted` (server-authoritative,
 * convive con multi-usuario/offline). El undo L1 inmediato (pill / Ctrl+Z) es
 * local-first; ESTE es el "deshacer duradero" del historial.
 *
 * NOTA (fallback sin tipos): el endpoint aún no está en los tipos generados de
 * `@mealplan/client` (requiere `make rust-gen-api-types` con el server
 * compilable), así que hacemos un fetch NO tipado que replica el transporte
 * web cookie-BFF (cookie de dispositivo `credentials: "include"` + selector
 * `X-Active-Account`). Al regenerar los tipos, migrar a `api.POST(...)`.
 */
import { SERVER_BASE_URL } from "@/lib/api";
import { readActiveAccountSelector } from "@/lib/accounts";

export async function revertActivity(id: string): Promise<void> {
  const headers: Record<string, string> = { "content-type": "application/json" };
  const selector = readActiveAccountSelector();
  if (selector) {
    headers["X-Active-Account"] = selector;
  }
  const response = await fetch(`${SERVER_BASE_URL}/api/activity/${encodeURIComponent(id)}/revert`, {
    method: "POST",
    credentials: "include",
    headers,
  });
  if (!response.ok) {
    throw new Error(`revert failed with status ${response.status}`);
  }
}
